import { DateTime } from 'luxon';

import { AutoLotView, normalizeAuctionStartDatetime } from '../const';
import { LotStatusEnum } from '../modules/graphql/service/graphql-auto-main-service';

export const NEGOTIATIONS_OVERSTEP = 20_000;

export function isNegotiationsLot(lot: AutoLotView): boolean {
  return lot?.status === LotStatusEnum.Negotiations && Number(lot.negotiationsPrice) > 0;
}

export function getLotBiddingDeadline(lot: AutoLotView): DateTime {
  const closure = lot.tradingClosureBiddingEndsAt
    ? DateTime.fromISO(lot.tradingClosureBiddingEndsAt)
    : null;

  if (isNegotiationsLot(lot)) {
    const midnight = DateTime.fromISO(lot.date || lot.time, { zone: 'Asia/Tokyo' })
      .startOf('day')
      .plus({ days: 1 });
    const endsAt = lot.negotiationsEndsAt ? DateTime.fromISO(lot.negotiationsEndsAt) : midnight;
    return DateTime.min(midnight, endsAt, ...(closure ? [closure] : []));
  }

  return closure || normalizeAuctionStartDatetime(lot.time);
}

export function hasLotBiddingDeadlineOverride(lot: AutoLotView): boolean {
  return !!lot.tradingClosureBiddingEndsAt || isNegotiationsLot(lot);
}

export function isLotTradingClosed(lot: AutoLotView, now = DateTime.now()): boolean {
  return (
    !!lot.tradingClosed ||
    (isNegotiationsLot(lot) && lot.negotiationsAvailable === false) ||
    (hasLotBiddingDeadlineOverride(lot) && now >= getLotBiddingDeadline(lot))
  );
}
